/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `spo2_data` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class Spo2DataMesg : Mesg {
    public constructor() : super("Spo2Data", Profile.MesgNum.SPO2_DATA)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** reading_spo2, in percent. */
    public var readingSpo2: UByte?
        get() = getFieldValue(READING_SPO2_FIELD_NUM) as? UByte
        set(value) = setFieldValue(READING_SPO2_FIELD_NUM, value)

    /** reading_confidence. */
    public var readingConfidence: UByte?
        get() = getFieldValue(READING_CONFIDENCE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(READING_CONFIDENCE_FIELD_NUM, value)

    /** mode. Mode when data was captured */
    public var mode: Spo2MeasurementType?
        get() = (getFieldValue(MODE_FIELD_NUM) as? UByte)?.let { Spo2MeasurementType.fromValue(it) }
        set(value) = setFieldValue(MODE_FIELD_NUM, value?.value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val READING_SPO2_FIELD_NUM: UByte = 0u
        public const val READING_CONFIDENCE_FIELD_NUM: UByte = 1u
        public const val MODE_FIELD_NUM: UByte = 2u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("ReadingSpo2", 0u, BaseType.UINT8, 1.0, 0.0, "percent", false)
            fields[1] = Field("ReadingConfidence", 1u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[2] = Field("Mode", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
